import {
    updateDriverFullName,
    updateInsuredFullName,
    updateOtherDriverFullName,
    updateOtherInsuredFullName
} from './update-people-data';

if ($('.create.dllbg-mtr-claim, .update.dllbg-mtr-claim').length) {

    $('input[name="other_insured_last_name"], input[name="other_insured_name"]').on('input', updateOtherInsuredFullName);
    $('input[name="insured_last_name"], input[name="insured_name"]').on('input', updateInsuredFullName);
    $('input[name="driver_last_name"], input[name="driver_name"]').on('input', updateDriverFullName);
    $('input[name="other_driver_last_name"], input[name="other_driver_name"]').on('input', updateOtherDriverFullName);

    updateOtherInsuredFullName();
    updateInsuredFullName();
    updateOtherDriverFullName();
    updateDriverFullName();
}
